import React, { useEffect, useState } from "react";
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import "./Changelog.scss";
import routes from "../../utils/routes.json";
import NavTo from "../../components/NavTo/NavTo";
import Button from "../../components/Buttons/Button/Button";

import landingBefore from '../../assets/img/changelog/landing-before.png';
import landingAfter from '../../assets/img/changelog/landing-after.png';
import walletBefore from '../../assets/img/changelog/wallet-before.png';
import walletAfter from '../../assets/img/changelog/wallet-after.png';
import marketBefore from '../../assets/img/changelog/market-before.png';
import marketAfter from '../../assets/img/changelog/market-after.png';
import stockBefore from '../../assets/img/changelog/stock-before.png';
import stockAfter from '../../assets/img/changelog/stock-after.png';
import leaderboardBefore from '../../assets/img/changelog/leaderboard-before.png';
import leaderboardAfter from '../../assets/img/changelog/leaderboard-after.png';

const changelogData = [
  {
    title: "Landing Page",
    desc: "Refonte de la page d'accueil avec un design moderne (glassmorphism) et animations fluides.",
    item1: landingBefore,
    item2: landingAfter
  },
  {
    title: "Wallet",
    desc: "Nouvelle interface pour le portefeuille.",
    item1: walletBefore,
    item2: walletAfter
  },
  {
    title: "Market",
    desc: "Mise à jour de la page des marchés boursiers.",
    item1: marketBefore,
    item2: marketAfter
  },
  {
    title: "Stock",
    desc: "Vue détaillée des actions améliorée.",
    item1: stockBefore,
    item2: stockAfter
  },
  {
    title: "Leaderboard",
    desc: "Nouveau classement dynamique.",
    item1: leaderboardBefore,
    item2: leaderboardAfter
  }
];

function Changelog() {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentSection = changelogData[activeTab];

  return (
    <div className="containerPage changelog-containerPage">
      <div className="card changelog-card">
        <div className="changelog-layout">
          
          <div className="changelog-sidebar">
            <div className="changelog-header-custom">
              <h1 className="mb-0 title-with-badge">
                Changelog
                <span className="badge-refonte">Refonte 2026</span>
              </h1>
            </div>
            
            <div className="changelog-tabs-vertical">
              {changelogData.map((section, index) => (
                <button 
                  key={index} 
                  className={`tab-btn-vertical ${activeTab === index ? 'active' : ''}`}
                  onClick={() => setActiveTab(index)}
                >
                  {section.title}
                </button>
              ))}
            </div>

            <div className="changelog-footer-sidebar">
              <NavTo className="custom-link w-100" path={routes.home}>
                <Button styles={"button black w-100"}>
                  Voir en direct
                </Button>
              </NavTo>
            </div>
          </div>

          <div className="changelog-content">
            <div className="changelog-section" key={activeTab}>
              <div className="slider-wrapper">
                <ReactCompareSlider
                  itemOne={
                    <div className="slider-item-wrapper">
                      <div className="slider-label label-before">Avant</div>
                      <ReactCompareSliderImage src={currentSection.item1} alt={`${currentSection.title} Before`} style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
                    </div>
                  }
                  itemTwo={
                    <div className="slider-item-wrapper">
                      <div className="slider-label label-after">Après</div>
                      <ReactCompareSliderImage src={currentSection.item2} alt={`${currentSection.title} After`} style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
                    </div>
                  }
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Changelog;
